module.exports = __webpack_public_path__ + "static/media/channel management.8470bd6e.svg";